export enum Role {
  OWNER = "Owner",
  SUPERVISOR = "Supervisor",
  OPERATOR = "Operator",
  CUSTOMER = "Customer",
}
